import SharedContentListContainer from 'containers/SharedContentContainer/SharedContentListContainer';

export const SharedLearningsListScreen = () => (
  <SharedContentListContainer listType="learnings" />
);

export default SharedLearningsListScreen;
